import config from "https://raw.githubusercontent.com/uuf6429/console-progress-designer/refs/heads/main/config.mjs";
import CpdApp from "_resources/cpd/app.mjs";
import "_resources/cpd/app.scss";
new CpdApp(config);